export default "__VITE_ASSET__RXrGr_Nc__"